import React from 'react';
export function Hook() {
  return <section className="w-full border-y border-line bg-surface" data-id="element-76" data-mp="3vca56wzhfdz">
      <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-77" data-mp="2b6v4v3mp0huz">
        <p className="font-display text-4xl font-bold uppercase leading-[1.02] tracking-tightest text-white sm:text-5xl" data-id="element-78" data-mp="1x6k9poecoh40">
          Let’s be honest: knowing how to train is not enough anymore.
        </p>
        <div className="mt-8 space-y-6 font-sans text-lg leading-relaxed text-muted" data-id="element-79" data-mp="2oxqc6bhjmqwg">
          <p data-id="element-80" data-mp="2p02varz1f7b3">
            HYROX is growing faster than any other sport in the world. The
            competition is getting fiercer. The athletes are getting faster. And
            as a coach, you are either evolving with the sport or you are
            getting left behind.
          </p>
          <p data-id="element-81" data-mp="2k4x8zs1q3qmh">
            If your athletes are training hard but failing to improve their
            times… if they are crashing mid-race or losing minutes in the
            transitions…
          </p>
        </div>
        <p className="mt-8 border-l-2 border-volt pl-6 font-display text-3xl font-bold uppercase leading-tight tracking-tightest text-white sm:text-4xl" data-id="element-82" data-mp="2a0nt5ereaxee">
          It’s not their effort. It’s your system.
        </p>
      </div>
    </section>;
}